import { render } from "./ClockEnd.vue?vue&type=template&id=fbafe3e4"
import script from "./ClockEnd.vue?vue&type=script&lang=js"
export * from "./ClockEnd.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__